import { RouteLocationNormalized } from 'vue-router';

/** Возвращает true, если при навигации была смена раздела.
 * Примеры:
 * 1. Вернет true, когда переход из `/directions` в `/quotas`
 * 2. Вернет false, когда переход `/partnerships/partners` в `/partnerships/contracts`
 */
export const isRouteSectionChange = (from: RouteLocationNormalized, to: RouteLocationNormalized) => from.path.split('/')[1] !== to.path.split('/')[1];
